<label class="c-switch">
	@if (label) {
		<span class="sr-only">{{ label }}</span>
	}
	<input class="c-switch__input" type="checkbox" [formControl]="form" />
	<span class="c-switch__slider"></span>
</label>
